<template>
  <div class="flex flex-col w-full h-full p-1 animate-pulse gap-6">
    <div class="flex flex-col gap-2">
      <div class="h-4 w-48 bg-slate-200 rounded"></div>
      <div class="h-4 w-48 bg-slate-200 rounded"></div>
      <div class="h-3 w-32 bg-slate-200 rounded mt-1"></div>
    </div>
    <div class="flex">
      <div class="h-6 w-24 bg-slate-200 rounded"></div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="h-5 w-40 bg-slate-200 rounded"></div>
      <div class="flex gap-2 overflow-hidden">
        <div class="h-24 w-40 bg-slate-200 rounded-lg border border-slate-300"></div>
        <div class="h-24 w-40 bg-slate-200 rounded-lg border border-slate-300"></div>
        <div class="h-24 w-40 bg-slate-200 rounded-lg border border-slate-300"></div>
      </div>
    </div>

    <div class="flex justify-between mt-2">
      <div class="flex flex-col gap-2 w-1/5">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="flex flex-col gap-2 w-1/5">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
        <div class="h-4 w-24 bg-slate-200 rounded"></div>
      </div>
      <div class="flex flex-col gap-2 w-1/5">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
      </div>
      <div class="flex flex-col gap-2 w-1/5">
        <div class="h-4 w-24 bg-slate-200 rounded"></div>
        <div class="h-4 w-32 bg-slate-200 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
